import type {IAdData} from '../../../definitions';

export function setBackground(data: IAdData) {
  const bg = data.data.background;

  // bg color
  if (!bg.color && !bg.image) {
    return;
  }

  const elements = document.querySelectorAll<HTMLElement>('.wrapper .coc-top, .wrapper .coc-sky');

  for (const element of elements) {
    // set background color
    if (bg.color) {
      element.style.backgroundColor = bg.color;
    }

    // set background image
    if (bg.image) {
      element.style.backgroundImage = 'url(' + bg.image + ')';
    }

    // set background repeat
    if (bg.repeat) {
      let repeat = '';
      switch (bg.repeat) {
        case 'x':
          repeat = 'repeat-x';
          break;
        case 'y':
          repeat = 'repeat-y';
          break;
      }
      element.style.backgroundRepeat = repeat;
    }
  }

  // bg clickable
  if (bg.clickUrl === '') {
    return;
  }

  for (const element of elements) {
    element.style.cursor = 'pointer';
    element.addEventListener('click', function(e) {
      const target = e.target as Element;
      if (target.tagName.toLowerCase() !== 'object') {
        window.open(bg.clickUrl);
      }
    });
  }
}
